/**
 * Escapa texto antes de ele entrar em HTML montado como string (`v-html`,
 * `html` do SweetAlert, `innerHTML`). Cobre aspas também: o texto pode cair
 * dentro de um atributo (`href="..."`, `title="..."`), e sem elas um `"` no
 * conteúdo fecha o atributo e abre outro.
 *
 * Onde der, prefira `{{ }}`/`textContent`, que já escapam sozinhos — isto é
 * para quando o HTML precisa ser montado à mão.
 */
export function escapeHtml(valor: string | number | null | undefined): string {
    return String(valor ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
